export default "__VITE_ASSET__DGv5ENIA__"